/* @flow */
import React from "react";
import styled, { css, keyframes, ThemeConsumer } from "styled-components";
import { color as rgba } from "d3-color";

function fade(color, alpha) {
  color.opacity = alpha;
  return color.toString();
}

const pulse = keyframes`
  from {
    transform: scale(1.1);
  }

  to {
    transform: scale(0.6);
  }
`;

const Shadow = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-clip: padding-box;
  border-radius: 50%;
  box-shadow: 0px 0px 6px 4px;
  animation: ${pulse} 1s linear infinite alternate;
`;

const DotView = styled.div`
  position: absolute;
  top: -7px;
  left: -7px;
  width: 14px;
  height: 14px;
  background-clip: padding-box;
  border-radius: 50%;
  z-index: 99;

  &:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: transparent;
    background-clip: padding-box;
    border-radius: 50%;
    box-shadow: 0px 0px 5px 3px;
  }

  ${props =>
    props.mobile &&
    css`
      top: -5px;
      left: -5px;
      width: 10px;
      height: 10px;
    `};
`;

const Center = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: inherit;
  background-clip: padding-box;
  border: 2px solid;
  border-radius: 50%;
  z-index: 100;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    height: 50%;
    background-color: transparent;
    background-clip: padding-box;
    border: 3px solid;
    border-radius: 50%;
  }

  ${props =>
    props.mobile &&
    css`
      border: 1px solid;

      &:before {
        border: 2px solid;
      }
    `};
`;

type Props = {
  x: number,
  y: number,
  color: string,
  theme: Object,
  mobile?: boolean
};

function Dot({ x, y, color, mobile, theme }: Props) {
  const bgColor = rgba(theme.main);
  const rgbaColor = rgba(color);

  return (
    <DotView
      style={{
        WebkitTransform: `translateX(${x}px) translateY(${y}px)`,
        transform: `translateX(${x}px) translateY(${y}px)`,
        backgroundColor: fade(bgColor, 1),
        color: fade(bgColor, 0.25) // is needed in order for boxShadow to inherit color
      }}
      mobile={mobile}
    >
      <Shadow
        style={{
          backgroundColor: fade(rgbaColor, 0.59),
          color: fade(rgbaColor, 0.59)
        }}
      />
      <Center
        style={{
          color: fade(rgbaColor, 1) // is needed in order for border to inherit color
        }}
        mobile={mobile}
      />
    </DotView>
  );
}

export default (props: Props) => (
  <ThemeConsumer>{theme => <Dot {...props} theme={theme} />}</ThemeConsumer>
);



// WEBPACK FOOTER //
// ./src/components/Chart/Dot.js